function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';

var useToastWrapper = _ref => {
  var {
    dismiss,
    dismissable
  } = _ref;
  var drag = React.useRef({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0
  });
  var [style, setStyle] = React.useState({});

  function getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
  }

  var _onTouchStart = e => {
    drag.current.x = getX(e.nativeEvent);
    drag.current.start = drag.current.x;
  };

  var _onTouchMove = e => {
    if (e.changedTouches && e.changedTouches.length && dismissable) {
      drag.current.x = getX(e);
      drag.current.delta = drag.current.x - drag.current.start;
      drag.current.removalDistance = 355 * (50 / 100);
      setStyle(previous => _objectSpread(_objectSpread({}, previous), {}, {
        transform: "translateX(".concat(drag.current.delta, "px)"),
        opacity: 1 - Math.abs(drag.current.delta / drag.current.removalDistance)
      }));
    }
  };

  var _onTouchEnd = () => {
    if (Math.abs(drag.current.delta) > drag.current.removalDistance && dismissable) {
      console.log('dismiss');
      dismiss();
    } else {
      setStyle(previous => _objectSpread(_objectSpread({}, previous), {}, {
        transform: "translateX(".concat(0, "px)"),
        opacity: 1,
        transition: 'transform 0.2s, opacity 0.2s'
      }));
    }
  };

  return {
    _onTouchStart,
    _onTouchMove,
    _onTouchEnd,
    style
  };
};

export { useToastWrapper };
//# sourceMappingURL=useToastWrapper.js.map